export default __webpack_public_path__ + "static/media/dedication1.8e617edb.png";